import { useQuery } from "@tanstack/react-query";
import { getWhyChooseUsItemById } from "../../api/apiWhyChooseUs";

export function useGetWhyChooseUsItem(id) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["why-choose-us-item", id],
        queryFn: () => getWhyChooseUsItemById(id),
        enabled: !!id,
        retry: false,
    });

    const item = data?.data || null;

    return { isLoading, error, item, refetch };
}
